import { useController } from 'react-hook-form';

import ErrorMessage from '@/components/ErrorMessage';
import {
	Select as BaseSelect,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue
} from '@/components/Select';

import Label from './Label';

export { SelectContent, SelectItem, SelectValue, SelectTrigger };

export function Select({
	name,
	label,
	id,
	control,
	disabled,
	required,
	errorMessageProps,
	...props
}) {
	const { field, fieldState } = useController({
		name,
		control,
		disabled
	});

	return (
		<div className="form-input flex flex-col">
			{label && (
				<Label htmlFor={id}>{`${label}${required ? '*' : ''}`}</Label>
			)}
			<BaseSelect
				name={name}
				onValueChange={field.onChange}
				value={field.value}
				error={fieldState.invalid}
				disabled={disabled}
				{...props}
			/>
			{fieldState.error?.message && (
				<ErrorMessage {...errorMessageProps}>
					{fieldState.error.message}
				</ErrorMessage>
			)}
		</div>
	);
}

export default Select;
